import { render } from "./PendingSignaturesPanel.vue?vue&type=template&id=c1afc45e&scoped=true"
import script from "./PendingSignaturesPanel.vue?vue&type=script&lang=js"
export * from "./PendingSignaturesPanel.vue?vue&type=script&lang=js"

import "./PendingSignaturesPanel.vue?vue&type=style&index=0&id=c1afc45e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1afc45e"]])

export default __exports__